import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Route, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { VimCoreTrackingService } from '../../../../vendor/tracking';
import { UserService } from '../services/user.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class AuthorizedGuard {
  constructor(
    private userService: UserService,
    private router: Router,
    private vimCoreTrackingService: VimCoreTrackingService,
    private translocoService: TranslocoService,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkLogin();
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkLogin();
  }

  canLoad(route: Route): Observable<boolean> {
    return this.checkLogin();
  }

  private checkLogin(): Observable<boolean> {
    if (this.userService.isAuthenticated()) {
      return of(true);
    }

    return this.userService.loadUser().pipe(
      tap(isUserLoaded => {
        if (!isUserLoaded) {
          window.alert(this.translocoService.translate('sharedModule.authorizedGuard.loginFailed'));
          this.router.navigate(['user', 'login', { redirect: window.location.href }]);
          return;
        }

        const user = this.userService.getUser();
        this.vimCoreTrackingService.setUserData(user.id, {
          name: user.name,
          email: user.email,
          user_role: JSON.stringify(user.roles),
        });
      }),
    );
  }
}
